import sub from "date-fns/sub";

export const COW_CONNECT_MODULE_ID = "bf8fb31d-5843-4bd8-8ce0-63c4393d13dc";

export const NO_GRAPH_CP: number[] = [208];
export const NO_MAX_CP: number[] = [208, 209];
export const NO_MIN_CP: number[] = [];

export const METRIC_ID_FAT_AND_PROTEIN = "5794613f-23df-4741-9635-baef1d0c856d";
export const METRIC_ID_MILK_AND_DMI = "7eb62be6-6fbb-46b7-9aa6-12baa5587f1b";
export const METRIC_ID_BLENDS = "857feac6-58aa-4034-9582-9a72b208f97e";
export const METRIC_ID_TASKS = "d2696c10-513d-4e5d-b0f0-61a3a6143110";
export const METRIC_ID_COSTS = "d6336688-ef24-41d7-8f19-ceffa1bf6e5c";
export const METRIC_ID_FORAGE_ANALYSIS = "1025faa9-ed4a-44d7-8852-774b584e171a";
export const KPI_ID_LITRES_PER_COW = "a01efafe-7963-4e87-a488-8d94760cd09c";
export const KPI_ID_KG_PER_COW = "b0505320-6a92-4951-a8bf-4f1dbac530d8";
export const KPI_ID_COST_PER_LITRE = "fd829627-0705-430f-bc80-8a238497e116";
export const KPI_ID_MOAF = "22973492-50b4-4515-ac17-80e8226d2aa6";
export const AVAILABLE_CURRENCIES = ["GBP", "EUR", "USD", "DKK", "RUB", "CZK"];

export const DURATIONS = {
  days3: sub(new Date(), { days: 3 }),
  days7: sub(new Date(), { days: 7 }),
  days14: sub(new Date(), { days: 14 }),
  months1: sub(new Date(), { months: 1 }),
  months3: sub(new Date(), { months: 3 }),
  months6: sub(new Date(), { months: 6 }),
  months12: sub(new Date(), { months: 12 }),
};

export const Colors = [
  `rgba(0, 178, 227, 1)`, //blue
  `rgba(0, 168, 135, 1)`, //green
  `rgba(243, 39, 53, 1)`, //red
  `rgba(65, 0, 153, 1)`, //purple
  `rgba(255, 95, 0, 1)`, //orange
  `rgba(255, 183, 27, 1)`, //yellow
  `rgba(0, 105, 147, 1)`, //navy
  `rgba(166, 126 , 204, 1)`, //purple
  `rgba(149, 216, 241, 1)`, //blue
  `rgba(255, 161, 147, 1)`, //red
  `rgba(96, 214, 192, 1)`, //green
  `rgba(255, 179, 127, 1)`, //orange
  `rgba(255, 218, 150, 1)`, //yellow
];
export const defaultColors = (index: number, opacity: number) => {
  const _index = isNaN(index) ? 0 : index;
  const _opacity = isNaN(opacity) ? 1 : opacity;
  return Colors[_index % Colors.length]?.replace("1)", _opacity + ")");
};

export const HEATMAP_COLORS = [
  "transparent",
  "rgb(0, 0, 0)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 93, 14)",
  "rgb(245, 127, 32)",
  "rgb(248, 153, 29)",
  "rgb(227, 179, 35)",
  "rgb(202, 204, 44)",
  "rgb(175, 209, 54)",
  "rgb(156, 203, 59)",
  "rgb(137, 197, 64)",
  "rgb(122, 193, 67)",
  "rgb(0, 230, 0)", /// 100
  "rgb(122, 193, 67)",
  "rgb(137, 197, 64)",
  "rgb(156, 203, 59)",
  "rgb(175, 209, 54)",
  "rgb(202, 204, 44)",
  "rgb(227, 179, 35)",
  "rgb(248, 153, 29)",
  "rgb(245, 127, 32)",
  "rgb(212, 93, 14)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(212, 14, 60)",
  "rgb(0,0,0)",
];

export const base64Logo =
  "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";
